import { Skeleton } from 'shared/ui/skeleton'

interface Props {
  className: string
}

export const SkeletonPromo = ({ className }: Props) => {
  return (
    <Skeleton
      width={300}
      height={102}
      className={className}
    />
  )
}
